import { Trans, useTranslation } from 'next-i18next'
import { useState } from 'react'

import StartAnalytics from '~/analytics/start/startAnalytics'

export interface FAQItemProps {
  questionKey?: string
  answerKey?: string
  question?: string
  answer?: React.ReactNode
  isSubscriptionFAQ?: boolean
  translationNamespace?: string
  translationPrefix?: string
}

export default function FAQItem({
  questionKey,
  answerKey,
  question,
  answer,
  translationNamespace = 'start',
  translationPrefix = 'FAQ.',
}: FAQItemProps): React.ReactElement {
  const { t } = useTranslation(translationNamespace)
  const [showAnswer, setShowAnswer] = useState(false)
  const questionText = question ?? t(`${translationPrefix}${questionKey}`)

  const questionClick = (): void => {
    setShowAnswer(!showAnswer)
    StartAnalytics.logButtonClick(questionText)
  }

  return (
    <div className="bg-white w-full rounded text-black-light p-5 md:py-3 md:px-6 text-left">
      <button
        aria-expanded={showAnswer}
        className="flex justify-between items-center w-full text-left"
        onClick={questionClick}
        type="button"
      >
        <h3 className="text-md md:text-md font-bold">{questionText}</h3>
        <span className="text-5xl font-extralight leading-none">{showAnswer ? '-' : '+'}</span>
      </button>
      <div className="text-md mt-4" hidden={!showAnswer}>
        {answer ?? (
          <Trans
            components={{ br: <br />, indent: <span className="ml-4" />, space: <span className="block mt-4" /> }}
            i18nKey={`${translationPrefix}${answerKey}`}
            ns={translationNamespace}
            t={t}
          />
        )}
      </div>
    </div>
  )
}
